import {
  PRIVILEGED_ACTIONS_LIST_SET,
  PRIVILEGED_ACTIONS_LIST_REQ,
  PRIVILEGED_ACTIONS_LIST_SUCCESS,
  PRIVILEGED_ACTIONS_LIST_ERROR,
  PRIVILEGED_ACTIONS_LIST_RESET_STATUS,
  IOC_DETECTIONS_LIST_SET,
  IOC_DETECTIONS_LIST_REQ,
  IOC_DETECTIONS_LIST_SUCCESS,
  IOC_DETECTIONS_LIST_ERROR,
  IOC_DETECTIONS_LIST_RESET_STATUS,
  IOC_DETAILS_REQ,
  IOC_DETAILS_SUCCESS,
  IOC_DETAILS_ERROR,
  ALL_IOC_DETECTIONS_LIST_SET,
  PRIVILEGED_IOC_LIST_RANGE_SET,
  PRIVILEGED_IOC_LIST_RANGE_REQ,
  PRIVILEGED_IOC_LIST_RANGE_SUCCESS,
  PRIVILEGED_IOC_LIST_RANGE_ERROR,
  PRIVILEGED_IOC_LIST_RANGE_RESET_STATUS,
  IOC_LIST_RANGE_SET,
  IOC_LIST_RANGE_REQ,
  IOC_LIST_RANGE_SUCCESS,
  IOC_LIST_RANGE_ERROR,
  IOC_LIST_RANGE_RESET_STATUS,
  IOC_DAILY_ACTIVITY_SET,
  IOC_DAILY_ACTIVITY_REQ,
  IOC_DAILY_ACTIVITY_SUCCESS,
  IOC_DAILY_ACTIVITY_ERROR,
  IOC_DAILY_ACTIVITY_RESET_STATUS,
  PRIVILEGED_IOC_DAILY_ACTIVITY_SET,
  PRIVILEGED_IOC_DAILY_ACTIVITY_REQ,
  PRIVILEGED_IOC_DAILY_ACTIVITY_SUCCESS,
  PRIVILEGED_IOC_DAILY_ACTIVITY_ERROR,
  PRIVILEGED_IOC_DAILY_ACTIVITY_RESET_STATUS,
  IOC_TACTIC_SUMMARY_SET,
  IOC_TACTIC_SUMMARY_REQ,
  IOC_TACTIC_SUMMARY_SUCCESS,
  IOC_TACTIC_SUMMARY_ERROR,
  IOC_TACTIC_SUMMARY_RESET_STATUS,
  DETECTIONS_VIEW_PREFERENCES_REQ,
  SAVE_DETECTIONS_VIEW_PREFERENCES
} from './detections.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import Detection from '@/resources/models/Detection'
import { OrderByEnum } from '@/constants/orderby.constants'
import { getDateRangeChoice, getTimeSinceMidnight } from '@/utilities/datetime.helper'
import { iocDetectionsMetaInfo } from '@/column-header/detections/ioc-detections-meta'
import { privActionsMetaInfo } from '@/column-header/detections/priv-actions-meta'

const state = {
  iocDetectionsListReqStatus: '',
  iocDetectionsList: {},
  privilegedActionsListReqStatus: '',
  privilegedActionsList: {},
  iocDetailsReqStatus: '',
  allIocDetectionsList: {},
  iocListRangeReqStatus: '',
  iocListRange: {},
  privilegedIocListRangeReqStatus: '',
  privilegedIocListRange: {},
  iocDailyActivityReqStatus: '',
  iocDailyActivity: {},
  privilegedIocDailyActivityReqStatus: '',
  privilegedIocDailyActivity: {},
  iocTacticSummaryReqStatus: '',
  iocTacticSummary: {},
  detectionPreferences: []
}

const getters = {
  iocDetectionsListReqStatus: state => state.iocDetectionsListReqStatus,
  iocDetectionsList: state => state.iocDetectionsList,
  privilegedActionsListReqStatus: state => state.privilegedActionsListReqStatus,
  privilegedActionsList: state => state.privilegedActionsList,
  iocDetailsReqStatus: state => state.iocDetailsReqStatus,
  allIocDetectionsList: state => state.allIocDetectionsList,
  iocListRangeReqStatus: state => state.iocListRangeReqStatus,
  iocListRange: state => state.iocListRange,
  iocDailyActivityReqStatus: state => state.iocDailyActivityReqStatus,
  iocDailyActivity: state => state.iocDailyActivity,
  privilegedIocDailyActivityReqStatus: state => state.privilegedIocDailyActivityReqStatus,
  privilegedIocDailyActivity: state => state.privilegedIocDailyActivity,
  iocTacticSummaryReqStatus: state => state.iocTacticSummaryReqStatus,
  iocTacticSummary: state => state.iocTacticSummary,
  detectionPreferences: state => state.detectionPreferences
}

// Best Practice - updates state
const mutations = {
  [ALL_IOC_DETECTIONS_LIST_SET]: (state, data) => {
    state.allIocDetectionsList = data
  },
  [IOC_DETECTIONS_LIST_SET]: (state, data) => {
    state.iocDetectionsList = data
  },
  [PRIVILEGED_ACTIONS_LIST_SET]: (state, data) => {
    state.privilegedActionsList = data
  },
  [PRIVILEGED_ACTIONS_LIST_REQ]: state => {
    state.privilegedActionsListReqStatus = 'loading'
  },
  [PRIVILEGED_ACTIONS_LIST_SUCCESS]: (state, data) => {
    state.privilegedActionsListReqStatus = 'saved'
  },
  [PRIVILEGED_ACTIONS_LIST_ERROR]: (state, errMsg) => {
    state.privilegedActionsListReqStatus = 'error'
  },
  [PRIVILEGED_ACTIONS_LIST_RESET_STATUS]: state => {
    state.privilegedActionsListReqStatus = ''
  },
  [IOC_DETECTIONS_LIST_REQ]: state => {
    state.iocDetectionsListReqStatus = 'loading'
  },
  [IOC_DETECTIONS_LIST_SUCCESS]: (state, data) => {
    state.iocDetectionsListReqStatus = 'saved'
  },
  [IOC_DETECTIONS_LIST_ERROR]: (state, errMsg) => {
    state.iocDetectionsListReqStatus = 'error'
  },
  [IOC_DETECTIONS_LIST_RESET_STATUS]: state => {
    state.iocDetectionsListReqStatus = ''
  },
  [IOC_DETAILS_REQ]: state => {
    state.iocDetailsReqStatus = 'loading'
  },
  [IOC_DETAILS_SUCCESS]: (state, data) => {
    state.iocDetailsReqStatus = 'saved'
  },
  [IOC_LIST_RANGE_SET]: (state, data) => {
    state.iocListRange = data
  },
  [IOC_LIST_RANGE_REQ]: state => {
    state.iocListRangeReqStatus = 'loading'
  },
  [IOC_LIST_RANGE_SUCCESS]: (state, data) => {
    state.iocListRangeReqStatus = 'saved'
  },
  [IOC_LIST_RANGE_ERROR]: (state, errMsg) => {
    state.iocListRangeReqStatus = 'error'
  },
  [IOC_LIST_RANGE_RESET_STATUS]: state => {
    state.iocListRangeReqStatus = ''
  },
  [PRIVILEGED_IOC_LIST_RANGE_SET]: (state, data) => {
    state.privilegedIocListRange = data
  },
  [PRIVILEGED_IOC_LIST_RANGE_REQ]: state => {
    state.privilegedIocListRangeReqStatus = 'loading'
  },
  [PRIVILEGED_IOC_LIST_RANGE_SUCCESS]: (state, data) => {
    state.privilegedIocListRangeReqStatus = 'saved'
  },
  [PRIVILEGED_IOC_LIST_RANGE_ERROR]: (state, errMsg) => {
    state.privilegedIocListRangeReqStatus = 'error'
  },
  [PRIVILEGED_IOC_LIST_RANGE_RESET_STATUS]: state => {
    state.privilegedIocListRangeReqStatus = ''
  },
  [IOC_DAILY_ACTIVITY_SET]: (state, data) => {
    state.iocDailyActivity = data
  },
  [IOC_DAILY_ACTIVITY_REQ]: state => {
    state.iocDailyActivityReqStatus = 'loading'
  },
  [IOC_DAILY_ACTIVITY_SUCCESS]: (state, data) => {
    state.iocDailyActivityReqStatus = 'saved'
  },
  [IOC_DAILY_ACTIVITY_ERROR]: (state, errMsg) => {
    state.iocDailyActivityReqStatus = 'error'
  },
  [IOC_DAILY_ACTIVITY_RESET_STATUS]: state => {
    state.iocDailyActivityReqStatus = ''
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_SET]: (state, data) => {
    state.privilegedIocDailyActivity = data
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_REQ]: state => {
    state.privilegedIocDailyActivityReqStatus = 'loading'
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_SUCCESS]: (state, data) => {
    state.privilegedIocDailyActivityReqStatus = 'saved'
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_ERROR]: (state, errMsg) => {
    state.privilegedIocDailyActivityReqStatus = 'error'
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_RESET_STATUS]: state => {
    state.privilegedIocDailyActivityReqStatus = ''
  },
  [IOC_TACTIC_SUMMARY_SET]: (state, data) => {
    state.iocTacticSummary = data
  },
  [IOC_TACTIC_SUMMARY_REQ]: state => {
    state.iocTacticSummaryReqStatus = 'loading'
  },
  [IOC_TACTIC_SUMMARY_SUCCESS]: (state, data) => {
    state.iocTacticSummaryReqStatus = 'saved'
  },
  [IOC_TACTIC_SUMMARY_ERROR]: (state, errMsg) => {
    state.iocTacticSummaryReqStatus = 'error'
  },
  [IOC_TACTIC_SUMMARY_RESET_STATUS]: state => {
    state.iocTacticSummaryReqStatus = ''
  },
  [DETECTIONS_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.detectionPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [DETECTIONS_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserDetectionPrefs = data.find(pref => {
            return pref.tbl_id === 6 && pref.user_id === uid
          })
          context.commit(DETECTIONS_VIEW_PREFERENCES_REQ, currUserDetectionPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_DETECTIONS_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [IOC_DETECTIONS_LIST_REQ] (context, { dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.detectionsDateRangeUserSetting)
    }
    let detectionsUrl = `/ioc-detections/${lastXHours.hours}`
    if (lastXHours.value === 'SINCE_MIDNIGHT') {
      let timeSinceMidnight = getTimeSinceMidnight()
      detectionsUrl = `/trails/ioc-detections/range/${encodeURIComponent(
        timeSinceMidnight.starttime
      )}/${encodeURIComponent(timeSinceMidnight.endtime)}`
    }
    return new Promise((resolve, reject) => {
      context.commit(IOC_DETECTIONS_LIST_REQ)
      ApiRest()
        .get(detectionsUrl)
        // .get('static/json/ioclist.json')
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }

              if (_.isEmpty(detection.trailStateList)) {
                detection.trailStateList = ['ACTIVE']
              } else if (detection.trailStateList[0].toLowerCase().includes('privilege')) {
                detection.trailStateList = ['ACTIVE']
              }

              detection.rule = detectionRule
              detection.host = detectionHost
              return new Detection(undefined, detection)
            })
            .value()

          let detections = new IQCollection(
            data,
            { attributes: iocDetectionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )
          context.commit(IOC_DETECTIONS_LIST_SET, detections)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IOC_DETECTIONS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [IOC_DETECTIONS_LIST_SUCCESS] (context) {
    context.commit(IOC_DETECTIONS_LIST_SUCCESS)
  },
  [IOC_DETECTIONS_LIST_RESET_STATUS] (context) {
    context.commit(IOC_DETECTIONS_LIST_RESET_STATUS)
  },
  [PRIVILEGED_ACTIONS_LIST_REQ] (context, { dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.detectionsDateRangeUserSetting)
    }
    let actionsUrl = `/ioc-detections/privileged/${lastXHours.hours}`
    if (lastXHours.value === 'SINCE_MIDNIGHT') {
      let timeSinceMidnight = getTimeSinceMidnight()
      actionsUrl = `/trails/ioc-detections/privileged/range/${encodeURIComponent(
        timeSinceMidnight.starttime
      )}/${encodeURIComponent(timeSinceMidnight.endtime)}`
    }
    return new Promise((resolve, reject) => {
      context.commit(PRIVILEGED_ACTIONS_LIST_REQ)
      ApiRest()
        .get(actionsUrl)
        // .get('static/json/ioclist.json')
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }

              detection.rule = detectionRule
              detection.host = detectionHost
              return new Detection(undefined, detection)
            })
            .value()

          let activities = new IQCollection(
            data,
            { attributes: privActionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )

          context.commit(PRIVILEGED_ACTIONS_LIST_SET, activities)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(PRIVILEGED_ACTIONS_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [PRIVILEGED_ACTIONS_LIST_SUCCESS] (context) {
    context.commit(PRIVILEGED_ACTIONS_LIST_SUCCESS)
  },
  [PRIVILEGED_ACTIONS_LIST_RESET_STATUS] (context) {
    context.commit(PRIVILEGED_ACTIONS_LIST_RESET_STATUS)
  },
  [IOC_DETAILS_REQ] (context, iocId) {
    let iocIdEncoded = encodeURIComponent(iocId)
    return new Promise((resolve, reject) => {
      context.commit(IOC_DETAILS_REQ)
      ApiRest()
        .get(`/ioc-detections/${iocIdEncoded}`)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IOC_DETAILS_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [IOC_DETAILS_SUCCESS] (context) {
    context.commit(IOC_DETAILS_SUCCESS)
  },
  [IOC_LIST_RANGE_REQ] (context, { dateRangeSel } = {}) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(IOC_LIST_RANGE_REQ)
      ApiRest()
        .get(
          `/trails/ioc-detections/range/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
            timeSinceMidnight.endtime
          )}`
        )
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }

              detection.rule = detectionRule
              detection.host = detectionHost
              return new Detection(undefined, detection)
            })
            .value()

          let detections = new IQCollection(
            data,
            { attributes: iocDetectionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )

          context.commit(IOC_LIST_RANGE_SET, detections)

          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IOC_LIST_RANGE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [IOC_LIST_RANGE_SUCCESS] (context) {
    context.commit(IOC_LIST_RANGE_SUCCESS)
  },
  [IOC_LIST_RANGE_RESET_STATUS] (context) {
    context.commit(IOC_LIST_RANGE_RESET_STATUS)
  },
  [PRIVILEGED_IOC_LIST_RANGE_REQ] (context, { dateRangeSel } = {}) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(PRIVILEGED_IOC_LIST_RANGE_REQ)
      ApiRest()
        .get(
          `/trails/ioc-detections/privileged/range/${encodeURIComponent(
            timeSinceMidnight.starttime
          )}/${encodeURIComponent(timeSinceMidnight.endtime)}`
        )
        .then(({ data }) => {
          data = _.chain(data)
            .sort((a, b) => {
              return b.seenTime - a.seenTime // sort by desc
            })
            .map(detection => {
              let detectionRule = {}
              let detectionHost = {}

              if (detection.ruleid === 0) {
                detectionRule = {
                  id: 0,
                  name: detection.iocSummary
                }
              } else if (!_.isEmpty(context.rootState.rules.allRulesList)) {
                detectionRule = _.find(context.rootState.rules.allRulesList, {
                  id: `${detection.ruleid}`
                })
              }

              if (!_.isEmpty(context.rootState.agents.agentList.models)) {
                detectionHost = _.find(context.rootState.agents.agentList.models, {
                  agentId: detection.agentId
                })
              }

              detection.rule = detectionRule
              detection.host = detectionHost
              return new Detection(undefined, detection)
            })
            .value()

          let detections = new IQCollection(
            data,
            { attributes: iocDetectionsMetaInfo.meta.columns },
            { defaultSort: 'seenTime', sortOrder: OrderByEnum.DESC }
          )

          context.commit(PRIVILEGED_IOC_LIST_RANGE_SET, detections)

          resolve(data)
        })
        .catch(errMsg => {
          context.commit(PRIVILEGED_IOC_LIST_RANGE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [PRIVILEGED_IOC_LIST_RANGE_SUCCESS] (context) {
    context.commit(PRIVILEGED_IOC_LIST_RANGE_SUCCESS)
  },
  [PRIVILEGED_IOC_LIST_RANGE_RESET_STATUS] (context) {
    context.commit(PRIVILEGED_IOC_LIST_RANGE_RESET_STATUS)
  },
  [IOC_DAILY_ACTIVITY_REQ] (context, { dateRangeSel } = {}) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(IOC_DAILY_ACTIVITY_REQ)
      ApiRest()
        .get(
          `/trails/ioc-detections/dailyactivity/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
            timeSinceMidnight.endtime
          )}`
        )
        .then(({ data }) => {
          context.commit(IOC_DAILY_ACTIVITY_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IOC_DAILY_ACTIVITY_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [IOC_DAILY_ACTIVITY_SUCCESS] (context) {
    context.commit(IOC_DAILY_ACTIVITY_SUCCESS)
  },
  [IOC_DAILY_ACTIVITY_RESET_STATUS] (context) {
    context.commit(IOC_DAILY_ACTIVITY_RESET_STATUS)
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_REQ] (context, { dateRangeSel } = {}) {
    let timeSinceMidnight = getTimeSinceMidnight()

    return new Promise((resolve, reject) => {
      context.commit(PRIVILEGED_IOC_DAILY_ACTIVITY_REQ)
      ApiRest()
        .get(
          `/trails/ioc-privileged/dailyactivity/${encodeURIComponent(timeSinceMidnight.starttime)}/${encodeURIComponent(
            timeSinceMidnight.endtime
          )}`
        )
        .then(({ data }) => {
          context.commit(PRIVILEGED_IOC_DAILY_ACTIVITY_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(PRIVILEGED_IOC_DAILY_ACTIVITY_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_SUCCESS] (context) {
    context.commit(PRIVILEGED_IOC_DAILY_ACTIVITY_SUCCESS)
  },
  [PRIVILEGED_IOC_DAILY_ACTIVITY_RESET_STATUS] (context) {
    context.commit(PRIVILEGED_IOC_DAILY_ACTIVITY_RESET_STATUS)
  },
  [IOC_TACTIC_SUMMARY_REQ] (context, { dateRangeSel } = {}) {
    let lastXHours = ''
    if (dateRangeSel) {
      lastXHours = getDateRangeChoice(dateRangeSel)
    } else {
      lastXHours = getDateRangeChoice(context.rootState.daterangePref.detectionsDateRangeUserSetting)
    }
    return new Promise((resolve, reject) => {
      context.commit(IOC_TACTIC_SUMMARY_REQ)
      ApiRest()
        .get(`/trails/ioc-detections/tactic/summary/${lastXHours.hours}`)
        .then(({ data }) => {
          context.commit(IOC_TACTIC_SUMMARY_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(IOC_TACTIC_SUMMARY_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [IOC_TACTIC_SUMMARY_SUCCESS] (context) {
    context.commit(IOC_TACTIC_SUMMARY_SUCCESS)
  },
  [IOC_TACTIC_SUMMARY_RESET_STATUS] (context) {
    context.commit(IOC_TACTIC_SUMMARY_RESET_STATUS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/detections/detections.module.js